import { cx } from "../../lib/cx.js";
import { ClearIcon, SearchIcon } from "./icons.js";
export function createAutocompleteDetachedSearchButtonComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteDetachedSearchButton(userProps) {
    var query = userProps.query,
      _userProps$placeholde = userProps.placeholder,
      placeholder = _userProps$placeholde === void 0 ? 'Search' : _userProps$placeholde,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      onClick = userProps.onClick,
      onClear = userProps.onClear,
      translations = userProps.translations;
    return createElement("div", {
      className: cx('ais-AutocompleteDetachedSearchButton', classNames.detachedSearchButton),
      onClick: onClick,
      onKeyDown: function onKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      },
      role: "button",
      tabIndex: 0,
      title: translations.detachedSearchButtonTitle
    }, createElement("div", {
      className: cx('ais-AutocompleteDetachedSearchButtonIcon', classNames.detachedSearchButtonIcon)
    }, createElement(SearchIcon, {
      createElement: createElement
    })), createElement("div", {
      className: cx('ais-AutocompleteDetachedSearchButtonPlaceholder', classNames.detachedSearchButtonPlaceholder),
      hidden: Boolean(query)
    }, placeholder), createElement("div", {
      className: cx('ais-AutocompleteDetachedSearchButtonQuery', classNames.detachedSearchButtonQuery)
    }, query), query && onClear && createElement("button", {
      type: "reset",
      className: cx('ais-AutocompleteDetachedSearchButtonClear', classNames.detachedSearchButtonClear),
      title: translations.detachedClearButtonTitle,
      onClick: function onClick(event) {
        event.stopPropagation();
        onClear();
      }
    }, createElement(ClearIcon, {
      createElement: createElement
    })));
  };
}